import { createApp } from 'vue'
import { createI18n } from 'vue-i18n'
import App from '../components/App.vue'
import { frTranslations } from '../translations/fr'
import { enTranslations } from '../translations/en'
import { deTranslations } from '../translations/de'
import { pickPreferredLocale, FALLBACK_LOCALE } from '../lib/locale'

const app = createApp(App)
const i18n = createI18n({
  locale: pickPreferredLocale(navigator.languages ?? [navigator.language]),
  fallbackLocale: FALLBACK_LOCALE,
  messages: {
    en: enTranslations,
    fr: frTranslations,
    de: deTranslations
  }
})

app.use(i18n)
app.mount('#app')
